import { Controller } from "@hotwired/stimulus"

/**
 * Modal Stimulus Controller
 *
 * Usage:
 *   <div data-controller="modal">
 *     <button data-action="modal#open">Open Modal</button>
 *     <div data-modal-target="overlay" class="hidden fixed inset-0 z-50 ...">
 *       <div data-modal-target="panel" class="...">
 *         <button data-action="modal#close">Close</button>
 *         ...content...
 *       </div>
 *     </div>
 *   </div>
 */
export default class extends Controller {
  static targets = ["overlay", "panel"]

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  open(event) {
    event?.preventDefault()
    this.overlayTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.overlayTarget.classList.add("opacity-100")
      this.overlayTarget.classList.remove("opacity-0")
      this.panelTarget.classList.add("translate-y-0", "opacity-100")
      this.panelTarget.classList.remove("translate-y-4", "opacity-0")
    })
    document.addEventListener("keydown", this.closeOnEscape)
    document.body.style.overflow = "hidden"
  }

  close(event) {
    event?.preventDefault()
    this.overlayTarget.classList.add("opacity-0")
    this.overlayTarget.classList.remove("opacity-100")
    this.panelTarget.classList.add("translate-y-4", "opacity-0")
    this.panelTarget.classList.remove("translate-y-0", "opacity-100")
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
    }, 200)
    document.removeEventListener("keydown", this.closeOnEscape)
    document.body.style.overflow = ""
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeBackground(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
    document.body.style.overflow = ""
  }
}
